import React from "react"

export const OverlapFilterEditor: React.FC = () => {
  return (
    <span className="text-sm text-coval-text-muted">
      Regions where the agent and persona speak simultaneously.
    </span>
  )
}
